import React from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../data/blogPosts';

const Blog: React.FC = () => {
  return (
    <section id="blog" className="blog">
      <div className="container">
        <h2>Our Blog</h2>
        <div className="blog-posts">
          {blogPosts.map((post) => (
            <article key={post.slug} className="blog-post">
              <img
                src={`${process.env.PUBLIC_URL}/${post.image}`}
                alt={post.imageAlt || `Article featured image: ${post.title}`}
              />
              <h3>{post.title}</h3>
              <p className="date">{post.date} · {post.author}</p>
              <p>{post.excerpt}</p>
              <Link to={`/blog/${post.slug}`} className="read-more">
                Read More
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;